<template>
    <div class="addressReceiving">
      <div class="dd"><img src="../assets/localImage/address.png" alt=""></div>
      <div class="xx addAdress"  v-if="addAdress.luckAddress == 'luckDraw'" @click="handle()" >
          <p>请先添加收货地址</p>
      </div>
      <div class="xx" v-else>
          <h2>收货人：{{addressData.ship_name}} <span>{{addressData.ship_mobile}}</span></h2>
          <p>{{addressData.ship_province}} {{addressData.ship_city}} {{addressData.ship_county}} {{addressData.ship_addr}}</p>
      </div>
      <!-- <div class="jr"><img src="../assets/localImage/path.png" alt=""></div> -->
    </div>
</template>
<script>
    export default {
        data() {
            return {
            
            };
        },
        props: {
            addressData: {
                type: Object,
                required:false,
				default() {
					return {
						
					} 
				}
            },
            addAdress:{
                type:String,
                default:'',
                required:false,
                luckAddress:"luckDraw"
            }
        },
        created(){
        },
        methods: {
            handle(){
                this.$parent.topHandle();
            }
        }
    }
</script>
<style scoped lang='less'>
.addressReceiving::before{
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 6px;
    background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
    background-size: 200px;
    content: '';
}
.addressReceiving{
    width: 100%;
    height: 180px;
    background-color: #ffffff;
    display: flex;
    padding: 22px 32px;
    justify-content: space-around;
    align-items: center;
    position: relative;
    .dd{
        width: 30px;
        height: 36px;
    }
    .jr{
        width: 12px;
        height: 22px;
    }
    .xx{
        width: 560px;
        height: 100%;
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        h2{
            font-size:28px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(51,51,51,1);
            span{margin-left: 50px;}
            margin-top: 10px;
        }
        p{
            font-size:26px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(119,119,119,1);
            margin-top: 10px;
        }
    }
    .addAdress{
        p{
            margin-top: 50px;
            color: #333333;
        }
    }
}
    
</style>